import { Button, Modal, Typography, Card, CardContent, Grid, FormGroup, FormControlLabel, Checkbox, CircularProgress } from "@mui/material";
import { makeStyles } from '@mui/styles';
import CheckIcon from '@mui/icons-material/Check';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import { TIPOS_USUARIO } from "constants/constants";
import { useDispatch } from "react-redux";
import { setAceptarTyc } from "app/features/TyC/tyCSlice";
import { generarOperacionCancelacion, generarCodigoQR } from "app/features/Profesionales/profesionalesAPI";
import { setCodigoQr } from "app/features/CodigoQr/codigoQrSlice";

const useStyles = makeStyles(theme => ({
    modalStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: 1
    },
    floatCenter: {
        display: 'flex',
        justifyContent: 'center'
    }
}));

export const ModalTyCCancelacion = ({ open, onClose, onSuccess, setValue, tasaRR = null, setTasaRR = null, valorMedioPago = null }) => {
    
    const clases = useStyles();
    const dispatch = useDispatch()
    const [aceptoTerminosYCondiciones, setAceptoTerminosYCondiciones] = useState(false);
    const userType = Number(localStorage.userType)
    const tpoTramite = Number(localStorage.tpoTramite)
    const [loading, setLoading] = useState(false);

    const handleClose = (event) => {
        setAceptoTerminosYCondiciones(false);
        onClose(event);
    }
    const handleCloseGuardar = async(event) => {
        setLoading(true);
        dispatch(setAceptarTyc())
        if(valorMedioPago !== null && valorMedioPago !== undefined) {
            const nroOperacion = await generarOperacionCancelacion(localStorage.idLegajo, tasaRR.fecha.replace(/\//g, "-"), tasaRR.montoTramite, tasaRR.conceptos.$values, tasaRR.itemsDeuda ? tasaRR.itemsDeuda.$values : null);
            setTasaRR({...tasaRR, nroOperacion})

            if(valorMedioPago === "2") {
                const qrResp = await generarCodigoQR(nroOperacion);
                if(qrResp) {
                    dispatch(setCodigoQr(qrResp));
                }
            }
        }
        handleClose(event);
        onSuccess();
        // Debo cambiar el resultado de pago a pagado...
        setLoading(false);
        if(tasaRR === null ){
            tpoTramite === 3 ? setValue("5") : setValue("6");
        }
        // tpoTramite === 3 ? setValue("5") : setValue("6");
    }
    
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={clases.modalStyle} 
        >
            <Card className={'card-aceptar-ddjj'}>
                <CardContent>
                    <Grid container style={{ marginBottom: 15 }}>
                        <Grid item container justifyContent="flex-end" >
                            <CloseIcon style={{ cursor: "pointer" }} onClick={handleClose} />
                        </Grid>
                            <Typography style={{ fontSize: 16 }} ><b>Manifiesto con carácter de DECLARACIÓN JURADA que no ejerceré la/s profesión/es  regladas por la Ley  10620 en jurisdicción 
                                de la provincia de buenos aires  y que la información consignada en esta solicitud es correcta y completa sin omitir sin falsear dato alguno que deba contener,
                                siendo fiel expresión  de la verdad. A su vez, presto expresa conformidad para que todas las notificaciones y/o comunicaciones que el CPCEPBA deba cursarme -referidas
                                a la presente solicitud- se dirijan a la casilla de correo electrónico y/o teléfono celular/ fijo denunciado en la presente, donde serán consideradas válidas todas las notificaciones que se me remitan. 
                                Dejo expresa constancia de conocer y aceptar los términos y condiciones establecidos por el CPCEPBA para la realización de la presente solicitud de cancelación.
                            </b></Typography>
                        <FormGroup>
                            <FormControlLabel value={aceptoTerminosYCondiciones} control={<Checkbox />} onClick={value => setAceptoTerminosYCondiciones(value.target.checked)} label="Acepto los términos y condiciones" />
                        </FormGroup>
                        <Grid item md={12} className={clases.floatCenter} sx={{ mt: 2 }}>
                            <Button
                                variant="contained"
                                disabled={!aceptoTerminosYCondiciones || loading}
                                sx={{ mr: 2 }}
                                onClick={handleCloseGuardar}
                                color="secondary"
                                type="submit"
                                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CheckIcon />}
                            >
                                Aceptar
                            </Button>
                            <Button variant="contained" color="error" disabled={loading} onClick={handleClose} type="submit" startIcon={<HighlightOffIcon />}>
                                Cancelar
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Modal>);
}

